<template>
  <div class="slider-canvas-container" :class="{ 'slider-canvas-container-background': grid }">
    <canvas
      id="slider-canvas"
      ref="sliderCanvas"
      @mousedown="handleMouseDown"
      @touchstart="handleMouseDown"
      @mouseup="handleMouseUp"
      @touchend="handleMouseUp"
      @mousemove="handleMouseMove"
      @touchmove="handleMouseMove"
      width="950px"
      height="935px"
    ></canvas>
    <canvas
      id="temp-slider-canvas"
      ref="tempSliderCanvas"
      class="temp-slider-canvas"
      @mousedown="handleMouseDown"
      @touchstart="handleMouseDown"
      @mouseup="handleMouseUp"
      @touchend="handleMouseUp"
      @mouseleave="handleMouseUp"
      @mousemove="handleMouseMove"
      @touchmove="handleMouseMove"
      width="950px"
      height="935px"
    ></canvas>
  </div>
</template>

<script>
export default {
  name: 'tr-slider-canvas',
  props: {
    grid: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      canvas: {},
      mainCtx: null,
      ctx: null,
      mouse: {
        current: {
          x: 0,
          y: 0,
        },
        previous: {
          x: 0,
          y: 0,
        },
        down: false,
      },
    };
  },

  mounted() {
    this.canvas = document.getElementById('slider-canvas');
    this.mainCtx = this.canvas.getContext('2d');
    this.mainCtx.translate(0.5, 0.5);
    this.mainCtx.imageSmoothingEnabled = false;
    let tempCanvas = document.getElementById('temp-slider-canvas');
    this.canvas = tempCanvas;
    this.ctx = tempCanvas.getContext('2d');
    // console.log(' this.canvas', this.canvas);
    this.$store.commit('TrSliderCanvas/SET_CANVAS', document.getElementById('slider-canvas'));
  },
  methods: {
    imgUpdate() {
      if (this.tool === 'eraser') {
        this.mainCtx.globalCompositeOperation = 'destination-out';
      } else {
        this.mainCtx.globalCompositeOperation = 'source-over';
      }
      this.mainCtx.drawImage(this.canvas, 0, 0);
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },
    drawLine() {
      if (this.mouse.down) {
        if (this.tool === 'eraser') {
          this.ctx.strokeStyle = '#ffffff';
          this.ctx.lineWidth = 20;
        } else {
          this.ctx.strokeStyle = '#000000';
          this.ctx.lineWidth = 4;
        }
        this.ctx.lineTo(this.currentMouse.x, this.currentMouse.y);
        this.ctx.lineCap = 'round';
        this.ctx.stroke();
      }
    },
    textMarker() {
      if (this.mouse.down) {
        // this.ctx.globalAlpha = 0.1;
        // this.mainCtx.globalAlpha = 0.01;
        this.textCtx.strokeStyle = this.$store.getters.toolColor;
        // this.textCtx.strokeStyle = 'rgba(100,10,100,0.3)';
        this.textCtx.lineTo(this.currentMouse.x, this.currentMouse.y);
        this.textCtx.lineWidth = this.$store.getters.toolSize;
        this.textCtx.lineCap = 'round';
        this.textCtx.stroke();
      }
    },
    drawCircle() {
      if (this.mouse.down) {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        //Save
        this.ctx.save();
        this.ctx.beginPath();
        let scalex = 1 * ((this.currentMouse.x - this.mouse.previous.x) / 2);
        let scaley = 1 * ((this.currentMouse.y - this.mouse.previous.y) / 2);
        this.ctx.scale(scalex, scaley);
        //Create ellipse
        let centerx = this.mouse.previous.x / scalex + 1;
        let centery = this.mouse.previous.y / scaley + 1;
        this.ctx.arc(centerx, centery, 1, 0, 2 * Math.PI);
        //Restore and draw
        this.ctx.restore();
        this.ctx.strokeStyle = this.$store.getters.toolColor;
        this.ctx.lineWidth = this.$store.getters.toolSize;
        this.ctx.stroke();
      }
    },
    drawRectangle() {
      if (this.mouse.down) {
        this.ctx.beginPath();
        this.ctx.strokeStyle = this.$store.getters.toolColor;
        this.ctx.lineWidth = this.$store.getters.toolSize;
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        this.ctx.moveTo(this.currentMouse.x, this.currentMouse.y);
        let width = this.currentMouse.x - this.mouse.previous.x;
        let height = this.currentMouse.y - this.mouse.previous.y;
        this.ctx.rect(this.mouse.previous.x, this.mouse.previous.y, width, height);
        this.ctx.stroke();
      }
    },
    handleMouseDown(event) {
      let pointer;
      event.preventDefault();
      this.imgUpdate();
      this.ctx.beginPath();
      this.mouse.down = true;
      pointer = event;
      if (event.type === 'touchstart' && event.touches && event.touches[0]) {
        pointer = event.touches[0];
      }
      this.mouse.current = {
        x: pointer.pageX,
        y: pointer.pageY,
      };
      this.mouse.previous = {
        x: this.currentMouse.x,
        y: this.currentMouse.y,
      };
      this.mouse.previous = {
        x: this.currentMouse.x,
        y: this.currentMouse.y,
      };

      this.ctx.moveTo(this.currentMouse.x, this.currentMouse.y);
    },
    handleMouseUp(event) {
      event.preventDefault();
      this.mouse.down = false;
      this.imgUpdate();
      let pointer = event;
      if (event.type === 'touchend' && event.touches && event.touches[0]) {
        pointer = event.touches[0];
      }
      this.mouse.previous = {
        x: pointer.pageX,
        y: pointer.pageY,
      };
    },
    handleMouseMove(event) {
      event.preventDefault();
      let pointer = event;
      if (event.type === 'touchmove' && event.touches && event.touches[0]) {
        pointer = event.touches[0];
      }
      this.mouse.current = {
        x: pointer.pageX,
        y: pointer.pageY,
      };
      switch (this.tool) {
        case 'rectangle':
          this.mainCtx.globalAlpha = 1;
          this.drawRectangle();
          break;
        case 'circle':
          this.mainCtx.globalAlpha = 1;
          this.drawCircle();
          break;
        case 'paintBrush':
        case 'eraser':
        default:
          this.drawLine();
          this.imgUpdate();
      }
    },
  },
  computed: {
    tool() {
      return this.$store.getters['TrSliderCanvas/tool'];
    },
    currentMouse() {
      let rect = this.$refs.sliderCanvas.getBoundingClientRect();
      let x = (this.mouse.current.x - rect.left) / this.$store.getters.scale;
      let y = (this.mouse.current.y - rect.top) / this.$store.getters.scale;
      return {
        x,
        y,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.slider-canvas-container {
  position: absolute;
  cursor: crosshair;
  #slider-canvas,
  #temp-canvas {
    position: absolute;
    pointer-events: auto;
    z-index: 1250;
    cursor: crosshair;
  }
  #slider-canvas {
    z-index: 1110;
    cursor: default;
    pointer-events: none;
  }
}
.slider-canvas-container-background {
  background-image: url('./kratkaHD.png');
  height: 100%;
  width: 100%;
}
</style>
